import { makeStyles, tokens } from '@fluentui/react-components'
import { bayerColors, bucketColors } from '../theme'

const COLORS = [
  bayerColors.navyMid, '#7a4ec2', '#d97706', '#0f766e', '#be185d',
  '#4338ca', '#059669', '#9333ea', bucketColors.highPriority, '#2563eb',
]

function hashName(name: string): number {
  let h = 0
  for (let i = 0; i < name.length; i++) h = ((h << 5) - h + name.charCodeAt(i)) | 0
  return Math.abs(h)
}

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/)
  if (parts.length >= 2) return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase()
  return (name[0] ?? '?').toUpperCase()
}

const useStyles = makeStyles({
  avatar: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    fontWeight: 600,
    color: '#fff',
    flexShrink: 0,
    userSelect: 'none',
    fontFamily: tokens.fontFamilyBase,
  },
})

interface UserAvatarProps {
  name: string
  size?: number
}

export function UserAvatar({ name, size = 24 }: UserAvatarProps) {
  const styles = useStyles()
  const bg = COLORS[hashName(name) % COLORS.length]
  const fontSize = Math.max(9, Math.round(size * 0.42))

  return (
    <span
      className={styles.avatar}
      style={{ width: size, height: size, fontSize, background: bg }}
      title={name}
      aria-label={name}
    >
      {getInitials(name)}
    </span>
  )
}
